import type { ReactNode } from "react";
import { paragraphs } from "@/help";

/**
 * A tip's wording, laid out the same wherever it shows: a blank line starts a new paragraph, and a
 * single line break stays a line break. `lead` (a bold name, say) runs into the first paragraph.
 */
export function HelpText({ text, lead }: { text: string; lead?: ReactNode }) {
  return (
    <>
      {paragraphs(text).map((paragraph, index) => (
        <span key={index} className="help-para">
          {index === 0 && lead ? <>{lead} </> : null}
          {paragraph}
        </span>
      ))}
    </>
  );
}
